import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import BugadiPiercingImage from '../../Assets/Piercing Services/Bugadi piercing.jpg';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function BugadiPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Bugadi Piercing UAE | 150 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Bugadi Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Bugadi Piercing 150 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={BugadiPiercingImage} alt="Bugadi Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Bugadi Piercing</h3>

          <p>
            Add a touch of tradition and elegance to your style with our professional Bugadi piercing services in the UAE, available at an affordable price of 150 AED. Bugadi piercing is a unique and culturally inspired ear piercing placed on the upper cartilage of the ear, traditionally popular in South Asian styles and now embraced as a trendy and fashionable choice worldwide. This beautiful piercing is perfect for individuals who want to combine heritage with modern fashion, creating a distinctive look that stands out with subtle sophistication. Whether you choose a classic stud, a decorative Bugadi ring, or a customized design, our expert specialists ensure precise placement for a balanced and aesthetically pleasing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each Bugadi piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Since Bugadi piercing is done on the cartilage, it requires expertise and accuracy, and our experienced specialists are trained to perform the procedure while minimizing discomfort and ensuring proper alignment.
          </p>

          <p>
            Bugadi piercing is ideal for individuals who want a stylish and meaningful ear piercing that reflects both culture and personal expression. Its placement on the upper ear makes it a standout feature while still maintaining a refined and elegant appearance. This piercing pairs beautifully with other ear piercings such as lobe, helix, or tragus, allowing you to create a curated and layered ear look. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your ear structure and personal style.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can sometimes feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is an essential part of maintaining your Bugadi piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your Bugadi piercing will heal effectively and remain a stylish and long-lasting addition to your look
          </p>

          <p>
            Our Bugadi piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted Bugadi piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a unique and elegant ear look effortlessly. Book your Bugadi piercing appointment today and celebrate style, culture, and individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Bugadi Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BugadiPiercing;